var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHowitworksshape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 487,
    height: 743,
    viewBox: "0 0 487 743",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.348 45.8526C47.6132 64.9532 2.66605 171.158 26.0931 286.582L26.5486 288.674L60.0432 379.992L146.153 361.246L260.794 340.67C203.807 383.755 141.946 427.902 108.479 446.144C40.3777 485.076 85.9449 514.6 94.6601 538.998C103.375 563.397 140.378 647.378 213.368 662.166C284.278 675.216 368.739 312.787 371.016 323.248C371.669 334.062 337.001 479.665 343.406 618.516C347.731 755.63 439.278 652.428 459.155 610.848C472.016 583.943 443.973 462.95 421.594 375.785L378.2 207.733L377.745 205.641C352.693 90.5712 262.075 18.2629 172.716 37.7172L135.348 45.8526Z",
    fill: "#00FAB0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowitworksshape);
export default __webpack_public_path__ + "static/media/howitworksshape.45c9ebb964328d8600a8541d2c4f2897.svg";
export { ForwardRef as ReactComponent };